const equipmentmanufacturers = {
	title: "Produsenter",
	stitle: "Produsent",
	new_title: "Ny produsent",
	edit_title: "Endre produsent: {name}",
	list_title: "Produsenter",
	list_subtitle: "Endre produsent",
	id: "ID",
	name: "Navn",
	status: "Status",
	reference_id: "Referanse",
};
export default equipmentmanufacturers;